export const LANGUAGES = [
  { label: 'Español', code: 'es' },
  { label: 'English', code: 'en' },
  { label: 'Português', code: 'pt' },
]